import { render, staticRenderFns } from "./importCustomers.vue?vue&type=template&id=5207acd2&"
import script from "./importCustomers.vue?vue&type=script&lang=js&"
export * from "./importCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports